<template>
  <div>
    <div v-if="comicLoadState === 'error'" class="comicLoadError">
      <h4>{{comicLoadError}}</h4>
      <router-link to="/">Back to homepage</router-link>
    </div>
    <div v-if="comicLoadState === 'loading'">
      <Loader v-bind:size="'large'"/>
    </div>
    <div v-if="comicLoadState === 'success'">
      <ComicNav v-bind:comicId="comicId" />
      <div v-if="comicData.comic.note" class="note" v-html="comicData.comic.note"></div>
      <Post
        v-if="comicData.originPost.text"
        v-bind:post="comicData.originPost"
      />
      <div
        class="contents"
        v-html="comicData.comic.content.split('./comics').join(api + '/comics')"
      ></div>
      <ThirtyFour v-if="comicId==34" />
      <ComicNav v-bind:comicId="comicId" />
      <NewPost v-bind:userHasSuggestion="userHasSuggestion()"/>
      <h3>Suggestions</h3>
      <p v-if="!hasPostsOfType('suggestion')">None yet!</p>
      <Post v-for="post in getPostsOfType('suggestion')" v-bind:key="post.pk_post_id" v-bind:post="post"/>
      <h3>Questions</h3>
      <p v-if="!hasPostsOfType('question')">None yet!</p>
      <Post v-for="post in getPostsOfType('question')" v-bind:key="post.pk_post_id" v-bind:post="post"/>
      <h3>Comments</h3>
      <p v-if="!hasPostsOfType('comment')">None yet!</p>
      <Post v-for="post in getPostsOfType('comment')" v-bind:key="post.pk_post_id" v-bind:post="post"/>
    </div>
  </div>
</template>

<script>
import ComicNav from './ComicNav'
import NewPost from './NewPost'
import Post from './Post'
import Loader from './Loader'

import ThirtyFour from './special/34.min.vue'

export default {
  name: 'main',
  components: {ComicNav, Post, NewPost, Loader, ThirtyFour},
  created () {
    this.fetchComicData()
  },
  methods: {
    fetchComicData () {
      let comicId = this.$route.params.comicId
      this.$store.dispatch('changeComic', comicId)
    },
    hasPostsOfType (type) {
      return this.getPostsOfType(type).length > 0
    },
    getPostsOfType (type) {
      return this.$store.state.comicData.posts.filter(p => p.type === type)
    },
    userHasSuggestion () {
      if (!this.$store.state.user || !this.$store.state.comicData) {
        return false
      }
      return this.$store.state.comicData.posts.filter(p => p.is_self_post === '1' && p.type === 'suggestion').length > 0
    }
  },
  watch: {
    '$route': 'fetchComicData'
  },
  params: ['comicId'],
  computed: {
    api () {
      return process.env.API_URL
    },
    comicId () {
      return this.$store.state.comicId
    },
    comicData () {
      return this.$store.state.comicData
    },
    user () {
      return this.$store.state.user
    },
    comicLoadError () {
      return this.$store.state.errors.comicLoadError
    },
    comicLoadState () {
      return this.$store.state.comicLoadState
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.note {
  background-color: #ddffdd;
  border-left-color: #618B29;
  border-left-style: solid;
  border-left-width: 2rem;
  padding: 2rem;
}

.comicLoadError {
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// Main.vue?73cf7524